import * as Sentry from '@sentry/sveltekit';
import { env } from '$env/dynamic/public';
import { FetchApiKitFailToFetchException } from 'Services/fetchApiKit';

const WRONG_ENV_MESSAGE = `Not in production environment (${
	env?.ENVIRONMENT || 'none'
} detected), skipping Sentry initialization`;
const NO_DSN_MESSAGE = `Sentry DSN not found, skipping Sentry initialization`;

const IGNORED_ERRORS = [
	"Can't find variable: gmo", // open bug in Chrome for iOS: https://issuetracker.google.com/issues/396043331
	FetchApiKitFailToFetchException.name,
	'NetworkError when attempting to fetch resource' // nothing we can do to fix this one
];

export const initClientSide = () => {
	if (env?.SVELTEKIT_SENTRY_DSN && env?.ENVIRONMENT === 'production') {
		Sentry.init({
			dsn: env.SVELTEKIT_SENTRY_DSN,
			release: process.env.SENTRY_RELEASE,
			environment: process.env.SENTRY_ENVIRONMENT,
			integrations: [Sentry.replayIntegration()],
			ignoreErrors: IGNORED_ERRORS,
			replaysSessionSampleRate: 0.3, // This sets the Replay sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
			tracesSampleRate: 0.3 // Capture 100% of the transactions. Adjust this value in production as necessary.
		});
	} else {
		console.log(env?.SVELTEKIT_SENTRY_DSN ? WRONG_ENV_MESSAGE : NO_DSN_MESSAGE);
	}
};

export const initServerSide = () => {
	if (env?.SVELTEKIT_SENTRY_DSN && env?.ENVIRONMENT === 'production') {
		Sentry.init({
			dsn: env.SVELTEKIT_SENTRY_DSN,
			release: process.env.SENTRY_RELEASE,
			environment: process.env.SENTRY_ENVIRONMENT,
			ignoreErrors: [FetchApiKitFailToFetchException.name],
			// Performance Monitoring
			tracesSampleRate: 0.3 // Capture 100% of the transactions. Adjust this value in production as necessary.
		});
	} else {
		console.log(env?.SVELTEKIT_SENTRY_DSN ? WRONG_ENV_MESSAGE : NO_DSN_MESSAGE);
	}
};
